import { Timepicker } from '@folio/stripes/components';
import classNames from 'classnames';
import React from 'react';
import dayjs from '../../utils/dayjs';
import css from './hiddenErrorField.css';
export default function TimeField(_a) {
    var value = _a.value, display = _a.display, inputRef = _a.inputRef, error = _a.error, onBlur = _a.onBlur, className = _a.className, onChange = _a.onChange;
    if (!display)
        return null;
    var valueWithSuffix = value;
    if (valueWithSuffix !== undefined && !valueWithSuffix.endsWith('Z')) {
        valueWithSuffix += 'Z';
    }
    return (React.createElement("div", { className: classNames(css.hiddenErrorFieldWrapper, className), title: error === null || error === void 0 ? void 0 : error.toString() },
        React.createElement(Timepicker, { required: true, value: valueWithSuffix, onChange: function (_e, newTime) {
                onChange(newTime === null || newTime === void 0 ? void 0 : newTime.substring(0, 5));
                onBlur();
            }, inputRef: inputRef, marginBottom0: true, usePortal: true, meta: {
                touched: true,
                error: error
            }, parser: function (time, _timezone, timeFormat) {
                if (!time)
                    return '';
                if (time.endsWith('Z')) {
                    return dayjs.utc(time, 'HH:mm').format(timeFormat);
                }
                if (dayjs.utc(time, timeFormat).isValid()) {
                    return dayjs.utc(time, timeFormat).format(timeFormat);
                }
                return time;
            }, timeZone: "UTC" })));
}
